import { callBackend } from './api';

const IMPORTS_LATEST_ENDPOINT = 'api/portfolio/imports/latest';
const IMPORTS_LATEST_CACHE_MS = 1500;

const latestImportsInFlightByKey = new Map();
const latestImportsCacheByKey = new Map();
const latestImportsCachedAtByKey = new Map();

export async function fetchLatestPortfolioImportStatus(options = {}) {
    const force = Boolean(options?.force);
    const cacheKey = String(options?.cacheKey || 'default');
    const now = Date.now();
    const hasCache = latestImportsCacheByKey.has(cacheKey);
    const cachedAt = latestImportsCachedAtByKey.get(cacheKey) || 0;
    const cacheIsFresh = hasCache && (now - cachedAt) < IMPORTS_LATEST_CACHE_MS;

    if (!force && cacheIsFresh) {
        return latestImportsCacheByKey.get(cacheKey) ?? null;
    }

    const inFlight = latestImportsInFlightByKey.get(cacheKey);
    if (inFlight) {
        return inFlight;
    }

    const nextPromise = callBackend(IMPORTS_LATEST_ENDPOINT, 'GET')
        .then((response) => {
            const normalized = response || null;
            latestImportsCacheByKey.set(cacheKey, normalized);
            latestImportsCachedAtByKey.set(cacheKey, Date.now());
            return normalized;
        })
        .finally(() => {
            latestImportsInFlightByKey.delete(cacheKey);
        });

    latestImportsInFlightByKey.set(cacheKey, nextPromise);
    return nextPromise;
}

export function clearLatestPortfolioImportStatusCache() {
    latestImportsInFlightByKey.clear();
    latestImportsCacheByKey.clear();
    latestImportsCachedAtByKey.clear();
}
